const ActionType = {
  RESET: 'agyle/RESET',
  SIGN_IN: 'agyle/SIGN_IN',
  SET_USER: 'agyle/SET_USER',
  UPDATE_SETTING: 'agyle/UPDATE_SETTING',
  UPDATE_NOTIFICATION_COUNT: 'agyle/UPDATE_NOTIFICATION_COUNT',
  UPDATE_COMPANY_SETTINGS: 'agyle/UPDATE_COMPANY_SETTINGS',
  UPDATE_COMPANY_LOGO: 'agyle/UPDATE_COMPANY_LOGO'
};

export default ActionType;
